import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../api/api.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import {AuthService} from '../auth.service';
import {CookieService} from 'ngx-cookie-service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  password = new FormControl('', [Validators.required, Validators.minLength(7)]);
  passwordRepeat = new FormControl('', [Validators.required, Validators.minLength(7)]);

  inProgres = false;

  passkey = undefined

  constructor(
    private authService: AuthService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private router: Router,
    private cookieService: CookieService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.passkey = this.activatedRoute.snapshot.paramMap.get("passkey")
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, this.translateService.instant('login.snackbar-action-1'), config);
  }

  setNewPassword() {
    if(this.password.value == this.passwordRepeat.value && this.password.valid) {
      this.inProgres = true;
      this.api.setNewPassword(this.passkey, btoa(this.password.value)).subscribe(() => {
        this.inProgres = false;
        this.router.navigateByUrl('/login')
      })
    }else {
      this.openSnackBar('Inserisci una password valida');
    }
  }

  getPassworErrorMessage() {
    return this.password.hasError('required') ? this.translateService.instant('login.null-value-error') :
      this.password.hasError('minlength') ? this.translateService.instant('login.password-not-valid') :
        '';
  }
}
